import { Shape, ShapeOptions } from "../Shape";
import { SVGParsedPathData } from "../../../svg/";
import { YZCanvasContext } from "../canvas";

export class RabbitShape extends Shape {
  constructor(options?: ShapeOptions) {
    super(options);
  }

  protected cloneShape(): RabbitShape {
    const shape = new RabbitShape({
      ...super.getBaseOptions()
    });
    return shape;
  }

  public toSVGPathData(): SVGParsedPathData[] {
    return [
      ["M", 0, 0],
      ["C", 15, 0, 15, -40, 5, -30],
      ["L", 0, 0],
      ["C", -15, 0, -15, -40, -5, -30],
      ["L", 0, 0],
      ["a", 15, 15, 0, 1, 1, 0, 2 * 15],
      ["a", 15, 15, 0, 1, 1, 0, -2 * 15]
    ];
  }
}

export default RabbitShape;
